// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"559":"8821b8ec","688":"dabe2e7f"}[chunkId] + ".chunk.css";
};